export default "__VITE_ASSET__0dcb3c72__"